import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import "react-reflex/styles.css";

import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import AddTenantNamespaceButton from "../input/AddTenantNamespaceButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";

function TenantNamespace ( props ) {

    const { t } = useTranslation();

    const { tenant } = props;

    const [ grid, setGrid ] = useState();
    const [ api, setApi ] = useState ();
    const [ schema, setSchema ] = useState();
    const [ disabled, setDisabled ] = useState(false);

    const setNotification = useSetRecoilState(notificationState);

    useEffect ( () => {

        ( async () => {

            let schema = await getSchema ( "TenantTranslation" );
            setSchema ( schema );

        } ) ();
        
    }, [] );

    useEffect( () => {

        if ( api ) {

            api.refresh ();

        }

    }, [api] );

    useEffect ( () => {

        setApi ( ( api ) => {

            if ( api ) {

                api.refresh ();

            }

            return api;

        } );

    }, [tenant] );

    const onGridInitialized = ( ( grid ) => {

        grid.selectionMode = "Row";

        grid.selectionChanged.addHandler ( ( grid ) => {


            if ( grid.selectedItems && grid.selectedItems[0] ) {

                setDisabled ( false );

            } else {

                setDisabled ( true );

            }

        } );

        grid.itemsSourceChanged.addHandler ( ( grid ) => {


            if ( grid.selectedItems && grid.selectedItems[0] ) {

                setDisabled ( false );

            } else {

                setDisabled ( true );

            }

        } );
        
        setGrid ( grid );

    } );

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };
    
    const onSuccess = ( msg ) => {
    
        notifySuccess ( msg );
    
    };
        
    const onFailure = ( reason ) => {
    
        notifyFailure ( reason.response ? reason.response.data : reason );
    
    };

    const makeItemName = ( row ) => {

        return `${t("columnName.tenantName")}: ${row.tenantName}, ${t("columnName.namespace")}: ${row.namespace}`;

    };

    const onModifyViewUrl = ( tenant, url ) => {

        return `${url}/${tenant?tenant.tenantId:undefined}`;

    }

    return <BasicCrudScreenType

        id="VwTenantTranslation"
        table="VwTenantTranslation"
        view="VwTenantTranslation"

        headerTitle={t("term.namespace")}

        noCreate
        noEdit
        noDelete
        noExcel
        
        noFilter
        
        onAppendButtonInFrontOfSearch={() =>

            <>

                <BasicCrudScreenActionItemLayout>

                    <AddTenantNamespaceButton
                        id="AddTranslationPath"
                        tenant={tenant}
                        refresh={api}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                    />

                </BasicCrudScreenActionItemLayout>

                <BasicCrudScreenActionItemLayout>

                    <DeleteSingleRecordButton
                        id="DeleteTenantNamespace"
                        disabled={disabled}
                        color="secondary"
                        grid={grid}
                        title={t("buttonName.deleteNamespace")}
                        schema={schema}
                        refresh={api}
                        makeItemName={makeItemName}
                        onSuccess={onSuccess}
                        onFailure={onFailure}
                    />

                </BasicCrudScreenActionItemLayout>

            </>

        }

        onInitialized={onGridInitialized}
        onApiInitialized={onApiInitialized}
        onModifyViewUrl={ ( url ) => onModifyViewUrl ( tenant, url ) }

    />

}

export default TenantNamespace;

